import { TotemAvatar } from '../TotemAvatar'
import type { TotemBorderStyle } from '../../types'

export function BorderSwatch({ style, emoji, imageUrl, size = 'md' }: { style: TotemBorderStyle; emoji: string; imageUrl?: string; size?: 'md' | 'lg' }) {
  const dim = size === 'lg' ? 'size-20 text-3xl' : 'size-10 text-lg'
  return (
    <TotemAvatar
      emoji={emoji}
      imageUrl={imageUrl}
      borderStyle={style}
      className={dim}
    />
  )
}
